// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"error_wrapper__4sqjP"};